module.exports = __webpack_public_path__ + "cc80774632de9d911284f4d6ae307bea.svg";